(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marque"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-circles-marquee-toggle]');
  if (!button) return;
  const section = button.closest('.circles-marquee');
  if (!section) return;
  const paused = section.classList.toggle('is-paused');
  button.setAttribute('aria-pressed', String(paused));
  button.textContent = paused ? button.dataset.resume : button.dataset.pause;
});

  } catch(e) { console.error(e); }
})();
})();
